const configs = {
  API_URL: import.meta.env.VITE_APP_API_URL || '#{VITE_APP_API_URL}#',
  REDIRECT_URI: import.meta.env.VITE_APP_REDIRECT_URI || '#{VITE_APP_REDIRECT_URI}#',
  API_TIME_OUT: 30000,
};

export default configs;